import { useEffect, useState } from 'react'
import {
  defaultLoginTheme,
  independenceDayLoginTheme,
  isZambiaIndependenceDay,
  LoginTheme,
  msUntilNextLusakaMidnight,
} from '../utils/independenceDay'

/**
 * Returns the login theme for "now" and re-evaluates exactly at Lusaka
 * midnight, so the page switches on 24 Oct 00:00 and reverts on 25 Oct 00:00
 * without a refresh. Also re-checks when the tab regains focus, because
 * browser timers pause while a computer sleeps.
 */
export function useIndependenceDayTheme(): {
  isIndependenceDay: boolean
  theme: LoginTheme
} {
  const [isIndependenceDay, setIsIndependenceDay] = useState(() =>
    isZambiaIndependenceDay(),
  )

  useEffect(() => {
    let timer: number | undefined
    const check = () => setIsIndependenceDay(isZambiaIndependenceDay())
    const schedule = () => {
      window.clearTimeout(timer)
      // Small buffer so the check lands just after midnight, never before.
      timer = window.setTimeout(() => {
        check()
        schedule()
      }, msUntilNextLusakaMidnight() + 500)
    }
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        check()
        schedule()
      }
    }
    schedule()
    document.addEventListener('visibilitychange', handleVisibility)
    return () => {
      window.clearTimeout(timer)
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [])

  return {
    isIndependenceDay,
    theme: isIndependenceDay ? independenceDayLoginTheme : defaultLoginTheme,
  }
}
